import React, { useState, useEffect, useRef }  from 'react';
import { ContentPopup } from 'components/ContentPopup.jsx';
import MenuTabButtons from './MenuTabButtons';
import MyDownloadsButton from './MyDownloadsButton';
import ConfirmEmailWithCode from 'components/ConfirmEmailWithCode.jsx';

const NeedsToConfirmEmail = ({ id, drawing, redrawInProgress, onSuccess }) => {
  const handleClick = (e) => {
    e.preventDefault()
    setShowPopUp( () => true );
  }

  const [showPopUp, setShowPopUp] = useState(false);
  const popupRef = useRef();

  const handleBackClick = (e) => {
    e.preventDefault();
  }

  const [subscription, setSubscription] = useState({})
  const [currencyName, setCurrencyName] = useState('')

  const popupContent = () => {
    let callback = () => {
      popupRef.current.style.display = "none";
      setShowPopUp(() => false);
    };

    const handleConfirmed = () => {
      callback()
      onSuccess();
    }

    return <ContentPopup
      contextClass="wrapper"
      myRef={popupRef}
      autoOpen={true}
      content={<ConfirmEmailWithCode onConfirmed={handleConfirmed} />}
      cancelButton={false}
      beforeClose={callback}
      notWide={true}
      modalStyle={{ width: '460px', minWidth: '0', maxWidth: '92vw' }}
    />;
  }
  return (
    <div className="downloadButtonscontainer with-menu-tab-buttons">

      <MenuTabButtons />

      <div className="inner">
        <div className="child">
          <button className={`btn btn-default btn-lg download-btn confirm-btn-with-icons-${window.I18nLocale}`} onClick={handleClick} disabled={redrawInProgress}>
            <img src={window.dxf_svg_and_pdf_icon} className="downloadIcons" alt="" /> {t('models.confirm_your_email')}
          </button>
        </div>
      </div>

      <MyDownloadsButton id={id} drawing={drawing} />

      {showPopUp &&  popupContent()}
    </div>
  )
}

export default NeedsToConfirmEmail;
